<template>
  <div v-bind="$attrs">
    <v-tabs v-model="activeTab" data-testid="so-tabs-nav">
      <v-tab
        v-for="(tab, index) in tabs"
        :key="`tab-${index}`"
        :value="index"
        :disabled="tab.disabled"
        tabindex="0"
        class="text-capitalize text-medium-emphasis"
        style="letter-spacing: normal"
        data-testid="so-tabs-nav-link"
        @click="$emit('update:modelValue', index)"
      >
        <SoIcon
          v-if="tab.icon"
          :icon="tab.icon"
          :color="tab.iconColor"
          class="mr-1"
        />
        {{ tab.title }}
      </v-tab>
    </v-tabs>
    <SoDivider v-if="divider" />
  </div>
  <v-window v-model="activeTab" data-testid="so-tabs">
    <slot />
  </v-window>
</template>

<script lang="ts">
  import { defineComponent, Fragment } from "vue"
  import SoIcon from "@/components/SoIcon.vue"
  import SoDivider from "../SoDivider.vue"
  import { ITab } from "@/types/Tabs"

  export default defineComponent({
    components: {
      SoIcon,
      SoDivider,
    },
    inheritAttrs: false,
    props: {
      modelValue: {
        type: Number,
        default: 0,
      },
      divider: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        activeTab: 0,
      }
    },
    computed: {
      tabs(): ITab[] {
        if (!this.$slots.default) return []
        const slotElements = this.$slots.default()
        let tabs
        // When rendering slots using v-for, Vue wraps them into a single Fragment element
        if (slotElements[0].type === Fragment) {
          tabs = slotElements[0].children
        } else {
          tabs = slotElements
        }

        return tabs.map((tab) => {
          return {
            disabled: tab.props?.disabled,
            title: tab.props?.title,
            icon: tab.props?.icon,
            iconColor: tab.props?.["icon-color"],
          }
        })
      },
    },
    watch: {
      modelValue(val: number) {
        this.activeTab = val
      },
      activeTab(val: number) {
        this.$emit("update:modelValue", val)
      },
    },
    created() {
      this.activeTab = this.modelValue
    },
  })
</script>
